module.exports = __webpack_public_path__ + "static/media/40_tn.aedd515d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/style/img/monuments/black/thumbnails/40_tn.jpg
// module id = 253
// module chunks = 0